import React from "react";

const Schedule = () => (
  <div className="row schedule">
    <div className="three columns header-col">
      <h1><span>開催要綱</span></h1>
    </div>

    <div className="nine columns main-col">
      <div className="row item">
        <div className="twelve columns">
          <p className="info">
          </p>
          <h4><span>２０２０年 一向一揆まつり開催中止のお知らせ</span></h4>
          
          新型コロナウイルスの影響に伴うお客様の安全面を考慮し、8月9日（日）に開催を予定しておりました当祭の中止を決定いたしました。<br /> 
          つきましては、当日を楽しみにしていただいた皆様には大変申し訳ございませんが、
          参加者の皆様の安全を考慮しての決定となりますので、ご理解いただきますよう、よろしくお願いいたします。<br /> 
          来年以降のご来場を心よりお待ち申し上げます。
          {/* <table className="tb-outline">
            <tbody>
            <tr><th>名称</th><td>鳥越一向一揆まつり</td></tr>
            <tr><th>開催日時</th><td>２０２０年８月９日（日）</td></tr>
            <tr><th>会場</th><td>道の駅 一向一揆の里 周辺</td></tr>
            <tr><th>主催</th><td>一向一揆まつり実行委員会</td></tr>
            </tbody>
          </table> */}
        </div>
      </div>
    </div>
  </div>
);

export default Schedule;



// WEBPACK FOOTER //
// ./src/components/Schedule.js